
import React from 'react';
import Button from '../../../components/base/Button';

const PricingSection: React.FC = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openZalo = () => {
    window.open('https://zalo.me/0961686191', '_blank');
  };

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bảng Giá Dịch Vụ
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Giá cả minh bạch, cạnh tranh với chất lượng dịch vụ 5 sao - Ủi thẳng bằng máy ủi của Đức STAHL
            </p>
          </div>

          {/* Khuyến mãi nổi bật */}
          <div className="bg-gradient-to-r from-red-500 to-pink-500 rounded-2xl p-8 text-white mb-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
            <div className="relative z-10">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-gift-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold">🎉 Giặt Chăn Mền 10.000đ/kg cho người dân Đà Lạt</h3>
              </div>
              <p className="text-xl mb-6 text-red-100">
                Áp dụng đến hết tháng này tại Giặt Ủi Minh Khôi
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="flex items-center bg-white/20 rounded-lg p-3">
                  <i className="ri-drop-line mr-3 text-xl"></i>
                  <span>Giặt nước nóng 70°C – Hóa chất Ecolab cao cấp</span>
                </div>
                <div className="flex items-center bg-white/20 rounded-lg p-3">
                  <i className="ri-time-line mr-3 text-xl"></i>
                  <span>Nhận buổi sáng trả ngày buổi chiều</span>
                </div>
                <div className="flex items-center bg-white/20 rounded-lg p-3">
                  <i className="ri-coupon-line mr-3 text-xl"></i>
                  <span>Tặng thêm phiếu giảm giá 10% cho lần giặt tiếp theo</span>
                </div>
              </div>
              <Button 
                variant="secondary" 
                size="lg"
                onClick={scrollToBooking}
                className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl"
              >
                <i className="ri-calendar-check-line mr-2"></i>
                Đặt ngay khuyến mãi
              </Button>
            </div>
          </div>

          {/* Bảng giá chính */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                <i className="ri-building-line mr-2 text-blue-600"></i>
                Dịch vụ doanh nghiệp
              </h3>
              
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-semibold text-gray-900">Giặt đồ khách sạn – spa</h4>
                    <span className="text-2xl font-bold text-blue-600">10.000 – 12.000 VND/kg</span>
                  </div>
                  <p className="text-gray-600 text-sm mb-2">Ga, khăn, áo choàng, rèm, đồng phục</p>
                  <p className="text-xs text-gray-500">* Giá chưa bao gồm VAT</p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm border-2 border-teal-200">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-semibold text-gray-900">Giặt chăn – mền (khuyến mãi)</h4>
                    <span className="text-2xl font-bold text-teal-600">10.000 VND/kg</span>
                  </div>
                  <p className="text-gray-600 text-sm mb-2">Áp dụng cho khách Đà Lạt</p>
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-xs inline-block">
                    <i className="ri-fire-line mr-1"></i>
                    Khuyến mãi hot
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                <i className="ri-home-line mr-2 text-purple-600"></i>
                Dịch vụ cá nhân
              </h3>
              
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-semibold text-gray-900">Giặt dân sinh</h4>
                    <span className="text-2xl font-bold text-purple-600">15.000 VND/kg</span>
                  </div>
                  <p className="text-gray-600 text-sm">Giặt sạch – sấy thơm – gấp gọn</p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-semibold text-gray-900">Giặt khô cao cấp</h4>
                    <span className="text-2xl font-bold text-amber-600">Tính theo món</span>
                  </div>
                  <p className="text-gray-600 text-sm mb-3">Vest, váy, áo dài, vải cao cấp</p>
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={openZalo}
                    className="text-amber-600 border-amber-600 hover:bg-amber-50"
                  >
                    <i className="ri-message-3-line mr-1"></i>
                    Liên hệ báo giá
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* Thông tin bổ sung */}
          <div className="mt-12 bg-blue-50 rounded-2xl p-8">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
              <div>
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-truck-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Giao nhận tận nơi</h4>
                <p className="text-gray-600 text-sm">Lấy đồ hoàn toàn MIỄN PHÍ</p>
              </div>
              
              <div>
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-flashlight-line text-red-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Express 3h siêu nhanh</h4>
                <p className="text-gray-600 text-sm">Phụ thu 100% cho dịch vụ siêu gấp</p>
              </div>
              
              <div>
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-iron-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Máy ủi STAHL Đức</h4>
                <p className="text-gray-600 text-sm">Ủi thẳng chuyên nghiệp, không nhăn</p>
              </div>
              
              <div>
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-line text-purple-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Hợp đồng dài hạn</h4>
                <p className="text-gray-600 text-sm">Giảm giá đặc biệt cho khách sạn</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
